import { AxiosResponse } from 'axios';
import { AVATAR_ANONYMOUS_NAME, AVATAR_CUSTOMER, AVATAR_SOURCE_TWILIO } from 'constants/avatar';
import { HTTP_REQUEST_METHODS } from 'constants/http';
import { axiosWithRetry } from 'utils/axios';

export type AvatarAuthenticateRequest = Required & Optional;

type Required = {
  conversationId: string;
};
type Optional = Partial<{
  avatarId: string;
  avatarSource: string;
  name: string;
  identityType: typeof AVATAR_CUSTOMER;
}>;

export interface AvatarAuthenticateResponse {
  twilioAccessToken: string;
}
export const avatarAuthenticateAsync = (
  req: AvatarAuthenticateRequest,
  accessToken: string,
): Promise<AxiosResponse<AvatarAuthenticateResponse>> => {
  const url = `${process.env.CHAT_BACKEND_BASE_URL}/conversation/avatarAuthenticate`;

  const request: AvatarAuthenticateRequest = {
    conversationId: req.conversationId,
    avatarId: req.avatarId || '',
    avatarSource: req.avatarSource || AVATAR_SOURCE_TWILIO,
    name: req.name || AVATAR_ANONYMOUS_NAME,
    identityType: req.identityType || AVATAR_CUSTOMER,
  };
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  return axiosWithRetry({
    method: HTTP_REQUEST_METHODS.POST,
    body: request,
    headers,
    url,
  });
};
